import { ProductoFormState } from './types';
import {
  colorMapping,
  ProductoEstadoLabels,
  ProductoEstado,
} from 'src/utils/enums/ProductoEstado';
import { discontinuarProductoF } from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ProductoFormState = {
  data: null,
  status: null,
  actions: null,
  insumos: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'productoForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },
    setFormStatusBorrador(state) {
      state.status = {
        id: ProductoEstado.Borrador,
        text: ProductoEstadoLabels[ProductoEstado.Borrador].toUpperCase(),
        color: colorMapping[ProductoEstado.Borrador],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: true,
          tooltip: 'Discontinuar el producto',
        },

        verificarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },

    setFormStatusVerificadoYActualizado(state) {
      state.status = {
        id: ProductoEstado.VerificadoYActualizado,
        text: ProductoEstadoLabels[
          ProductoEstado.VerificadoYActualizado
        ].toUpperCase(),
        color: colorMapping[ProductoEstado.VerificadoYActualizado],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al producto',
        },

        verificarProducto: {
          visible: false,
          disabled: false,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusVerificadoYDesactualizado(state) {
      state.status = {
        id: ProductoEstado.VerificadoYDesactualizado,
        text: ProductoEstadoLabels[
          ProductoEstado.VerificadoYDesactualizado
        ].toUpperCase(),
        color: colorMapping[ProductoEstado.VerificadoYDesactualizado],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al producto',
        },
        verificarProducto: {
          visible: false,
          disabled: false,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: false,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusNoVerificado(state) {
      state.status = {
        id: ProductoEstado.NoVerificado,
        text: ProductoEstadoLabels[ProductoEstado.NoVerificado].toUpperCase(),
        color: colorMapping[ProductoEstado.NoVerificado],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al producto',
        },
        verificarProducto: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusDiscontinuado(state) {
      state.status = {
        id: ProductoEstado.Discontinuado,
        text: ProductoEstadoLabels[ProductoEstado.Discontinuado].toUpperCase(),
        color: colorMapping[ProductoEstado.Discontinuado],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: false,
          disabled: false,
          tooltip: 'Discontinuar el producto',
        },
        verificarProducto: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: false,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusMatrizDiscontinuada(state) {
      state.status = {
        id: ProductoEstado.MatrizDiscontinuada,
        text: ProductoEstadoLabels[
          ProductoEstado.MatrizDiscontinuada
        ].toUpperCase(),
        color: colorMapping[ProductoEstado.MatrizDiscontinuada],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: false,
          disabled: false,
          tooltip: 'Discontinuar el producto',
        },
        verificarProducto: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: false,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusMatrizAveriada(state) {
      state.status = {
        id: ProductoEstado.MatrizAveriada,
        text: ProductoEstadoLabels[ProductoEstado.MatrizAveriada].toUpperCase(),
        color: colorMapping[ProductoEstado.MatrizAveriada],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al producto',
        },

        verificarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setFormStatusMatrizEnReparacion(state) {
      state.status = {
        id: ProductoEstado.MatrizEnReparacion,
        text: ProductoEstadoLabels[
          ProductoEstado.MatrizEnReparacion
        ].toUpperCase(),
        color: colorMapping[ProductoEstado.MatrizEnReparacion],
      };
      state.actions = {
        seleccionarInsumos: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar Insumos',
        },
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        discontinuarProductoF: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar al producto',
        },

        verificarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Verificar el producto',
        },

        actualizarProducto: {
          visible: true,
          disabled: true,
          tooltip: 'Actualizar el producto',
        },
      };
    },
    setModifyingInsumos(state) {
      // Guardar estado anterior.
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };
      state.actions = {
        seleccionarInsumos: {
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
          visible: state.actions!.seleccionarInsumos.visible,
        },
        guardar: {
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
          disabled: true,
          visible: true,
        },
        discontinuarProductoF: {
          visible: state.actions!.discontinuarProductoF.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
        verificarProducto: {
          visible: state.actions!.verificarProducto.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
        actualizarProducto: {
          visible: state.actions!.actualizarProducto.visible,
          disabled: true,
          tooltip: 'Por favor, termine de modificar insumos para guardar.',
        },
      };
    },
    setModifyingInsumosFinished(state) {
      // Restaurar estado anterior
      state.status = state.previousState!.status;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(discontinuarProductoF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(discontinuarProductoF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.producto.form.status;

export const selectDiscontinuarProductoF = (state: RootState) =>
  state.producto.form.actions?.discontinuarProductoF;

export const selectGuardar = (state: RootState) =>
  state.producto.form.actions?.guardar;

export const selectVerificarProducto = (state: RootState) =>
  state.producto.form.actions?.verificarProducto;

export const selectActualizarProducto = (state: RootState) =>
  state.producto.form.actions?.actualizarProducto;

export const selectSeleccionarInsumos = (state: RootState) =>
  state.producto.form.actions?.seleccionarInsumos;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusVerificadoYActualizado,
  setFormStatusVerificadoYDesactualizado,
  setFormStatusNoVerificado,
  setFormStatusDiscontinuado,
  setFormStatusMatrizAveriada,
  setFormStatusMatrizEnReparacion,
  setFormStatusMatrizDiscontinuada,
  setModifyingInsumos,
  setModifyingInsumosFinished,
} = formSlice.actions;

export default formSlice.reducer;
